import { createElement } from "react";
import { TFuncKey } from "react-i18next";

import Flex from "components/Flex";
import { AdditionalDocumentIcon } from "components/Icons/AdditionalDocumentIcon";
import Text from "components/Text";

import { useClientTranslation } from "hooks/useClientTranslation";

import { useStyles } from "./styles";
import { checklistItemVariants } from "./variants";

type ChecklistItemProps = {
  variant: keyof typeof checklistItemVariants;
};

export const ChecklistItem = ({ variant }: ChecklistItemProps) => {
  const { t } = useClientTranslation();
  const { classes } = useStyles();

  const item = checklistItemVariants[variant];

  if (!item) return null;

  const { icon, text } = item;
  const key = text as TFuncKey<"default">;
  const content = t(key);

  return (
    <Flex aria-label={content} as="li" direction="row" align="center" gap={16}>
      <div className={classes.icon}>{icon ? createElement(icon) : createElement(AdditionalDocumentIcon)}</div>

      <Text sizeVariant="md" className={classes.text}>
        {content}
      </Text>
    </Flex>
  );
};
